import styled from 'styled-components';

export const SpayPuppyNotice = styled.p`
  ${props => props.theme.typography.body};
  color: ${props => props.theme.colors.text.secondary};
  text-align: center;
  margin-top: ${props => props.theme.spacing(3)};
`;
